import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  NavbarLinkElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BasicBlock } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<NavbarLinkElement>["defaultData"] = {
  attributes: {
    color: "#000000",
    "font-family": "Arial",
    "font-size": "13px",
    "font-weight": "normal",
    "line-height": "22px",
    padding: "15px 10px",
    "padding-top": "15px",
    "padding-right": "10px",
    "padding-bottom": "15px",
    "padding-left": "10px",
    target: "_blank",
    "text-decoration": "none",
    "text-transform": "uppercase",
  },
  data: {},
};

export const NavbarLink = createBlock<NavbarLinkElement>({
  get name() {
    return t("Navbar Link");
  },
  defaultData,
  type: BasicType.NAVBAR_LINK,
  create: (payload) => {
    const defaultData: NavbarLinkElement = {
      type: BasicType.NAVBAR_LINK,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.NAVBAR_LINK,
  render(params) {
    return <BasicBlock params={params} tag="mj-navbar-link" />;
  },
});
